import type { IFormxRepository, FormCreateInput } from '../repositories/IFormxRepository.js';
import type { FormxFormEntity } from '../entities/FormxEntity.js';

interface Deps { formxRepository: IFormxRepository; }

export function createCreateFormxFormUseCase({ formxRepository }: Deps) {
  return async function createFormxForm(input: FormCreateInput): Promise<FormxFormEntity> {
    return formxRepository.createForm(input);
  };
}
